{
  "statementTransitions": {
    "fail": "Fallo",
    "reconcile": "Reconciliar"
  },
  "viewStatement": "Ver estado",
  "table": {
    "client": "Cliente",
    "organization": "Organización",
    "account": "Cuenta",
    "statementState": "Estado de declaración",
    "statementType": "Tipo de declaración",
    "actions": "Acciones"
  },
  "transitionStatements": {
    "title": "Declaraciones de transición",
    "bodyText": "Esto cambiará {{totalCount}} estados a RECONCILIADOS. Esta acción no se puede deshacer. ¿Desea continuar?",
    "transitionStatementsButton": "Transición",
    "clearSelectionButton": "Borrar la selección",
    "totalCount": "Todas las {{totalCount}} declaraciones seleccionadas",
    "selectAll": "Seleccionar todas las declaraciones {{totalCount}}",
    "allRowsOnPageSelected": "Se han seleccionado todas las {{totalCount}} filas de esta página. Total de filas seleccionadas {{selectedCount}}",
    "rowsSelected": "{{selectedCount}} filas seleccionadas"
  },
  "statementStates": {
    "AWAITING_REVIEW": "En espera de revisión",
    "FAILED": "Falló",
    "RECONCILED": "Reconciliado"
  },
  "statementTypes": {
    "OV_MONTHLY_ACCOUNT_STATEMENTS": "Declaraciones mensuales de la cuenta OneVest",
    "ANNUAL_PERFORMANCE_REPORT": "Informe anual de rendimiento",
    "ANNUAL_ACCOUNT_STATEMENTS": "Declaraciones de cuenta anuales",
    "QUARTERLY_ACCOUNT_STATEMENTS": "Declaraciones de cuenta trimestrales",
    "MONTHLY_ACCOUNT_STATEMENTS": "Declaraciones de cuenta mensuales",
    "CONSOLIDATED_MONTHLY_ACCOUNT_STATEMENTS": "Declaraciones de cuenta mensuales consolidadas",
    "TAX_SLIPS_1099R": "Formularios fiscales 1099R",
    "TAX_SLIPS_LAST_10_MONTHS": "Formularios fiscales de los últimos 10 meses",
    "TAX_SLIPS_FIRST_60_DAYS": "Formularios fiscales de los primeros 60 días",
    "TAX_SLIPS_T4RSP_RL2": "Formularios fiscales T4RSP RL2",
    "TAX_SLIPS_T4RIF_RL2": "Formularios fiscales T4RIF RL2",
    "TAX_SLIPS_T4A_RL1": "Formularios fiscales T4A RL1",
    "TAX_SLIPS_NR4": "Formularios fiscales NR4",
    "TAX_SLIPS_T5008": "Formularios fiscales T5008",
    "TAX_SLIPS_TRADING_SUMMARY": "Resumen de operaciones con formularios fiscales",
    "TAX_SLIPS_T5_RL3": "Formularios fiscales T5 RL3",
    "TAX_SLIPS_T3_RL16": "Formularios fiscales T3 RL16",
    "TAX_SLIPS_T3_BREAKDOWN": "Desglose de los formularios fiscales T3",
    "TAX_SLIPS_T5013_RL15": "Formularios fiscales T5013 RL15",
    "MANAGEMENT_FEES_ANNUAL_REPORT": "Informe anual sobre comisiones de gestión",
    "ADMINISTRATIVE_FEES_ANNUAL_REPORT": "Informe anual sobre comisiones administrativas",
    "TAX_SLIP_GENERAL": "Hoja de impuestos general",
    "TRADE_CONFIRMATION": "Confirmación de la operación",
    "TAX_SLIPS_CONSOLIDATED_1099": "Formularios fiscales consolidados 1099",
    "TAX_SLIPS_FORM_1042_S": "Formulario de comprobantes fiscales 1042 S",
    "TAX_SLIPS_FORM_1099_Q": "Formulario de comprobantes fiscales 1099 Q",
    "TAX_SLIPS_FORM_1099_R": "Formulario de comprobantes fiscales 1099 R",
    "TAX_SLIPS_FORM_2439": "Formulario de comprobantes fiscales 2439",
    "TAX_SLIPS_FORM_480_6A": "Formulario de comprobantes fiscales 480 6A",
    "TAX_SLIPS_FORM_480_6B": "Formulario de comprobantes fiscales 480 6B",
    "TAX_SLIPS_FORM_5498": "Formulario de comprobantes fiscales 5498",
    "TAX_SLIPS_T4_FHSA": "Formularios fiscales T4 FHSA"
  }
}
